import { gql } from "@apollo/client";

// fetch enabled flags once
export const ACTIVE_FLAGS = gql`
  query ActiveFlags($tenantId: ID!) {
    tenantActiveFeatureFlags(tenantId: $tenantId) {
      success
      data {
        key
        description
      }
      error
    }
  }
`;

// subscription for feature flag updates
export const FLAG_UPDATED = gql`
  subscription FlagUpdated($tenantId: ID) {
    featureFlagUpdated(tenantId: $tenantId) {
      type
      flag {
        id
        key
        description
        active
        createdAt
        updatedAt
        rules {
          id
          priority
          type
          attributeKey
          operator
          attributeVals
          variationOn
          active
        }
      }
    }
  }
`;
